import React, { createContext, useContext, useMemo, useState } from 'react';

const ScoreFiltersContext = createContext(null);

export function ScoreFiltersProvider({ children }) {
  const [query, setQuery] = useState('');
  const [sortKey, setSortKey] = useState('updated-desc');

  const value = useMemo(
    () => ({
      query,
      sortKey,
      setQuery,
      setSortKey,
    }),
    [query, sortKey]
  );

  return (
    <ScoreFiltersContext.Provider value={value}>
      {children}
    </ScoreFiltersContext.Provider>
  );
}

export function useScoreFilters() {
  const ctx = useContext(ScoreFiltersContext);
  if (!ctx) {
    throw new Error('useScoreFilters must be used within ScoreFiltersProvider');
  }
  return ctx;
}
